<template>
  <q-layout view="hHh lpR fFf">
    <q-page-container>
      <q-page class="row no-wrap" style="height: 100vh; overflow: hidden;">
        
        <div class="col-12 col-md-3 flex column justify-center items-center q-pa-lg" style="background: white; z-index: 10;">
          <div style="width: 100%; max-width: 400px;">
            <div class="text-center q-mb-sm">
              <img src="@/assets/douranovo.png" alt="DouraSoft Logo" style="width: 180px; height: auto;" />
            </div>

            <div class="q-mb-lg">
              <h5 class="text-h5 text-weight-medium q-ma-none q-mb-xs">
                {{ newPass.primeiraEtapa ? 'Recuperar Senha' : 'E-mail Enviado!' }}
              </h5>
              <p class="text-grey-7 q-ma-none">
                {{ newPass.primeiraEtapa
                  ? 'Digite seu e-mail para receber as instruções de recuperação'
                  : 'Cheque sua caixa de entrada para redefinir sua senha'
                }}
              </p>
            </div>

            <q-form v-if="newPass.primeiraEtapa" @submit="enviar" class="q-gutter-md">
              <q-input
                type="email"
                v-model="email"
                label="E-mail"
                hint="Digite seu E-mail"
                lazy-rules
                :rules="[val => val && val.length > 0 || 'Endereço de E-mail inválido']"
                autofocus
              />

              <div class="text-right">
                <q-btn
                  label="Enviar Link de Recuperação"
                  type="submit"
                  color="blue-7"
                  :loading="newPass.loadAlterar"
                >
                  <template v-slot:loading>
                    <q-spinner color="grey-10" size="1em" />
                  </template>
                </q-btn>
              </div>
            </q-form>

            <div v-else class="q-gutter-md">
              <q-banner rounded class="bg-positive text-white q-pa-md">
                <template v-slot:avatar>
                  <q-icon name="check_circle" size="md" />
                </template>
                <div class="text-body1">
                  E-mail enviado com sucesso! Verifique sua caixa de entrada e spam.
                </div>
              </q-banner>

              <div class="text-right">
                <q-btn
                  label="Voltar ao Login"
                  to="/login"
                  color="blue-7"
                />
              </div>
            </div>

            <q-separator class="q-my-lg" />

            <div class="row justify-between items-center text-body2">
              <router-link
                to="/login"
                class="text-blue-7"
                style="text-decoration: none;"
              >
                Fazer login agora
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-md-9 gt-sm carousel-container" :style="currentBackgroundStyle">
          <div class="overlay-gradient"></div>

          <div class="carousel-content" v-if="banners.length > 0">
            <transition name="fade" mode="out-in">
              <div :key="currentImageIndex" class="slide-content">
                <h2 class="slide-title" v-html="banners[currentImageIndex].title"></h2>
                <p class="slide-description" v-html="banners[currentImageIndex].description"></p>
                    
                <q-btn
                  v-if="banners[currentImageIndex].button_label && banners[currentImageIndex].button_link"
                  :label="banners[currentImageIndex].button_label"
                  :href="banners[currentImageIndex].button_link"
                  target="_blank"
                  color="white"
                  text-color="blue-7"
                  class="q-mt-md"
                  size="md"
                />
              </div>
            </transition>

            <div class="carousel-controls" v-if="banners.length > 1">
              <button
                v-for="(banner, index) in banners"
                :key="index"
                @click="goToSlide(index)"
                :class="['control-dot', { active: currentImageIndex === index }]"
              ></button>
            </div>
          </div>
        </div>

      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { createMetaMixin } from "quasar";
import axios from "@/axios-unauth";

export default {
  name: "AlterarSenha",
  mixins: [createMetaMixin({ title: "DSB | Recuperar Senha" })],
  data() {
    return {
      email: "",
      banners: [],
      currentImageIndex: 0,
      slideInterval: null
    };
  },
  computed: {
    newPass() {
      return this.$store.getters.enviar;
    },
    currentBackgroundStyle() {
      if (!this.banners.length) {
        return { background: "#f5f5f5" };
      }

      return {
        backgroundImage: `url(${this.banners[this.currentImageIndex].image_url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        transition: "background-image 0.8s ease-in-out"
      };
    }
  },
  methods: {
    enviar() {
      this.$store.dispatch("enviar", { email: this.email });
    },
    carregarBanners() {
        axios
          .get('/banners/index') 
            .then(res => {
              this.banners = res.data.banners;
              
              if (this.banners.length > 0) {
                  this.iniciarSlide();
              }
            });
    },
    iniciarSlide() {
        if (this.slideInterval) clearInterval(this.slideInterval);
        
        this.slideInterval = setInterval(() => {
            this.nextImage();
        }, 5000);
    },
    nextImage() {
        if (this.banners.length > 0) {
            this.currentImageIndex = (this.currentImageIndex + 1) % this.banners.length;
        }
    },
    goToSlide(index) {
        this.currentImageIndex = index;
        this.iniciarSlide(); 
    }
  },
  mounted() {
    this.carregarBanners();
  },
  beforeUnmount() {
    if (this.slideInterval) clearInterval(this.slideInterval);
  }
};
</script>

<style lang="stylus" scoped>
.q-btn
  transition all 0.3s ease

.carousel-container
  position relative
  overflow hidden

.overlay-gradient
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  background linear-gradient(to top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0) 100%)
  z-index 1

.carousel-content
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  display flex
  flex-direction column
  justify-content flex-end
  align-items flex-end
  padding 60px
  z-index 2

.slide-content
  max-width 600px
  margin-bottom 40px
  text-align right

.slide-title
  color white
  font-size 42px
  font-weight 700
  margin 0 0 6px 0
  line-height 1.2
  text-shadow 0 2px 8px rgba(0, 0, 0, 0.2)

.slide-description
  color white
  font-size 20px
  font-weight 300
  margin 0
  opacity 0.95
  line-height 1.5
  text-shadow 0 1px 4px rgba(0, 0, 0, 0.2)

.carousel-controls
  display flex
  gap 12px

.control-dot
  width 12px
  height 12px
  border-radius 50%
  border none
  background rgba(255, 255, 255, 0.4)
  cursor pointer
  transition all 0.3s ease
  padding 0

  &:hover
    background rgba(255, 255, 255, 0.6)
    transform scale(1.1)

  &.active
    background white
    width 32px
    border-radius 6px

.fade-enter-active, .fade-leave-active
  transition opacity 0.5s ease

// Vue 3 renamed the enter start class: `-enter` is never applied any more.
.fade-enter-from, .fade-leave-to
  opacity 0
</style>